'use client'
import * as LabelPrimitive from '@radix-ui/react-label'
import { styled } from '../config'

export const Label = styled(LabelPrimitive.Root, {
  userSelect: 'none',
  fontFamily: '$inter',
})
